import React from "react";
import scoreHeader from "../../accerts/svg/headers/scoreHeader.svg";
import mathHeader from "../../accerts/svg/headers/mathHeader.svg";
import hotsHeader from "../../accerts/svg/headers/hotHeader.svg";
import emsatHeader from "../../accerts/svg/headers/EmsatHeader.svg";
import logo from "../../accerts/svg/geniuslogo.png";

const EventHeader = ({ reportData }) => {
  const formatDate = (dateString) => {
    const options = {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
    };
    return new Date(dateString).toLocaleDateString("en-US", options);
  };

  const getHeaderImage = () => {
    if (!reportData?.event_code) return scoreHeader;

    const eventType = reportData.event_code.toLowerCase();

    if (eventType.includes("math")) return mathHeader;
    if (eventType.includes("hots")) return hotsHeader;
    if (eventType.includes("gist")) return hotsHeader;
    if (eventType.includes("wizklub") || eventType.includes("wit"))
      return hotsHeader;
    if (eventType.includes("emsat")) return emsatHeader;
    if (eventType.includes("genius")) return emsatHeader;

    return scoreHeader; // Default for 'score' and fallback
  };

  const isAtreyaEvent = () => {
    const eventCode = reportData?.event_code?.toLowerCase() || "";
    if (eventCode.includes("atreya")) return true;
    return window.location.pathname.toLowerCase().includes("atreyascholarship");
  };

  // Function to abbreviate long event names
  const getDisplayEventName = (eventName) => {
    if (!eventName) return "";
    if (eventName.includes("REVT")) {
      return "Revision Test";
    }
    // If event name is more than 26 characters, use abbreviation
    if (eventName.length > 26) {
      const eventNameLower = eventName.toLowerCase();

      // Define abbreviations for specific long event names
      if (eventNameLower.includes("youth entrepreneurship challenge")) {
        return "YEC";
      }
      if (eventNameLower.includes("career counselling")) {
        return "Career Counselling"; // This is already short enough, but you can abbreviate if needed
      }
      // Add more abbreviations as needed
      if (eventNameLower.includes("international english")) {
        return "IEL";
      }
      if (
        eventNameLower.includes("wizklub") ||
        eventNameLower.includes("intelligence test")
      ) {
        return "WIT";
      }

      // Generic abbreviation: take first letter of each word for long names
      const words = eventName.split(" ");
      if (words.length > 3) {
        return words.map((word) => word.charAt(0).toUpperCase()).join("");
      }

      return eventName; // Return original if no specific rule matches
    }

    return eventName; // Return original if within 26 characters
  };

  return (
    <div className="Mathheader">
      <img src={logo} className="headerLogo" alt="LOGO" />
      <img
        style={{ width: "100%" }}
        src={getHeaderImage()}
        alt={`${reportData?.event_code || "Event"} Header`}
      />
      {!isAtreyaEvent() && (
        <p className="examName mathExame">
          {getDisplayEventName(reportData?.event_code)}{" "}
          {["semi-finals", "finals"].includes(reportData?.level?.toLowerCase())
            ? ""
            : reportData?.level}
        </p>
      )}
      <p className="studentName">{reportData?.first_name}</p>
      <p className="schoolid">
        {isAtreyaEvent()
          ? "Atreya Scholarship Test"
          : reportData?.school_name}
      </p>
      <p className="date">{formatDate(reportData?.exam_submitted_at)}</p>
      <p className="grade">{reportData?.grade}</p>
    </div>
  );
};

export default EventHeader;
